{
  "common": {
    "continue": "Continue",
    "back": "Back",
    "next": "Next",
    "skip": "Skip",
    "loading": "Loading…",
    "logout": "Log out",
    "login": "Sign in",
    "signup": "Create account",
    "or": "or",
    "email": "Email",
    "phone": "Phone",
    "password": "Password",
    "name": "Full name",
    "portal": "Back to portal",
    "language": "Language",
    "english": "English",
    "swahili": "Kiswahili",
    "googleContinue": "Continue with Google",
    "googleDisabled": "Google sign-in is not configured on this server.",
    "mockContinue": "Continue with mock data",
    "errorGeneric": "Something went wrong. Please try again.",
    "saving": "Saving…",
    "edit": "Edit"
  },
  "onboarding": {
    "progress": "Step {{current}} of {{total}}",
    "welcome": {
      "eyebrow": "Welcome",
      "title": "Stay ahead of local flood risk",
      "body": "Choose your language. You can change it anytime in preferences.",
      "cta": "Get started"
    },
    "carousel": {
      "eyebrow": "How it works",
      "slide1Title": "Watch the places you care about",
      "slide1Body": "Home, work, school — without live location tracking.",
      "slide2Title": "Clear, local alerts",
      "slide2Body": "Rainfall, rivers, and official warnings in plain language.",
      "slide3Title": "You stay in control",
      "slide3Body": "Pick channels, quiet hours, and when we should notify you.",
      "cta": "Create your account"
    },
    "signup": {
      "eyebrow": "Account",
      "title": "Create your {{name}} account",
      "body": "Use phone or email.",
      "haveAccount": "Already have an account?",
      "useOtp": "Prefer SMS code instead?"
    },
    "verify": {
      "eyebrow": "Verify phone",
      "title": "Enter the code we sent",
      "body": "We sent a 6-digit code to {{phone}}.",
      "send": "Send code",
      "resend": "Resend code",
      "cta": "Verify and continue",
      "devOtp": "Dev OTP",
      "consent": "I agree to receive flood risk alerts for my saved places. Official emergency guidance always takes priority."
    },
    "persona": {
      "eyebrow": "About you",
      "title": "How will you use this app?",
      "body": "Pick one or more. You can change this later.",
      "driver": "Driver",
      "rider": "Rider",
      "resident": "Everyday resident",
      "other": "Other",
      "cta": "Continue"
    },
    "alerts": {
      "title": "Alert preferences",
      "body": "Choose how we reach you. Hazard type, severity and time of day are set by the system.",
      "allAlertsInfo": "You will receive all alerts for your places and your location, at any time.",
      "channelSms": "SMS",
      "channelPush": "Push",
      "channelWhatsapp": "WhatsApp",
      "channelEmail": "Email",
      "whatsappNeedsPhone": "Add a phone number first to enable WhatsApp.",
      "whatsappOptIn": "Turning this on is your opt-in to receive WhatsApp alert templates.",
      "alertLanguage": "Alert language",
      "needChannel": "Turn on at least one channel."
    },
    "phoneGate": {
      "title": "Add your phone number",
      "body": "Google accounts need a verified phone number to receive SMS and WhatsApp flood alerts.",
      "sendCode": "Send code",
      "verify": "Verify",
      "verified": "Phone verified",
      "phoneInUse": "This phone number already belongs to another account.",
      "invalidOtp": "That code is incorrect or has expired.",
      "resend": "Resend code",
      "resendIn": "Resend in {{seconds}}s",
      "changeNumber": "Change number",
      "goHome": "Go to my home"
    },
    "done": {
      "title": "You're set up",
      "body": "You're set up as a {{persona}}. Alerts follow where you are, by {{channels}}.",
      "noChannels": "none",
      "persona": "Persona",
      "alerts": "Alerts",
      "finishLater": "Finish later"
    }
  },
  "auth": {
    "residentLogin": "Resident login",
    "adminLogin": "Admin login",
    "signupTitle": "Create account",
    "callbackWorking": "Finishing sign-in…",
    "forgotPassword": "Forgot password",
    "forgotTitle": "Reset your password",
    "forgotBody": "Enter the email on your account. If it matches, we will send a reset link.",
    "forgotSent": "If an account exists for that email, reset instructions were sent.",
    "sendReset": "Send reset link",
    "resetTitle": "Choose a new password",
    "resetBody": "Use the link from your email, or paste the reset code.",
    "resetCode": "Reset code",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "resetCta": "Update password",
    "resetDone": "Password updated. You can sign in.",
    "passwordMismatch": "Passwords do not match.",
    "passwordShort": "Password must be at least 8 characters.",
    "backToLogin": "Back to sign in"
  },
  "prefs": {
    "title": "Preferences",
    "messageLanguage": "Alert message language",
    "messageLanguageHint": "Language for SMS and email alerts. App screens stay English or Kiswahili.",
    "minSeverity": "Minimum alert level",
    "minSeverityHint": "You will only get alerts at this level or higher.",
    "severityLow": "All alerts — including low risk",
    "severityWatch": "Watch and above — possible flooding",
    "severityWarning": "Warning and above — flooding likely",
    "severitySevere": "Severe only — dangerous flooding",
    "channels": "Channels",
    "channelsHint": "Choose how you receive advisories. SMS still respects STOP replies.",
    "loadError": "Could not load preferences from the server.",
    "reportTitle": "Report a hazard",
    "reportHint": "Flooding or an impassable road? Share the place, a short description, and an optional photo.",
    "reportCta": "Self report",
    "save": "Save preferences",
    "saved": "Preferences saved",
    "saveError": "Could not save preferences",
    "navHome": "Home",
    "navMap": "Map",
    "navAlerts": "Alerts",
    "navPrefs": "Prefs"
  },
  "report": {
    "fab": "Report",
    "title": "Report a hazard",
    "hazardType": "Hazard type",
    "description": "Description",
    "descriptionHint": "Describe what you see (8–2000 characters)",
    "placeName": "Place name (optional)",
    "location": "Your location",
    "locationDetecting": "Detecting location…",
    "locationCaptured": "Location captured",
    "locationUnavailable": "Location unavailable — please enable GPS",
    "photo": "Photo (optional, max 2.5 MB)",
    "photoTooBig": "Photo must be under 2.5 MB",
    "submit": "Submit report",
    "submitted": "Report submitted — thank you!",
    "myReports": "My reports",
    "noReports": "No reports yet.",
    "statusPending": "Pending review",
    "statusApproved": "Approved",
    "statusRejected": "Not accepted",
    "hazards": {
      "FLOOD": "Flood",
      "HEAVY_RAIN": "Heavy rain",
      "LIGHTNING": "Lightning",
      "STRONG_WIND": "Strong wind",
      "HEAT": "Heat",
      "AIR_QUALITY_DUST": "Air quality / dust",
      "DROUGHT": "Drought",
      "FIRE": "Fire",
      "EARTHQUAKE": "Earthquake",
      "LANDSLIDE": "Landslide",
      "OTHER": "Other"
    }
  },
  "map": {
    "title": "Live Risk Map",
    "subtitle": "Showing alerts for your saved places",
    "legend": "Legend",
    "filters": "Filters",
    "all": "All",
    "myLocation": "My location",
    "noAlerts": "No active alerts for your area",
    "alertSheet": {
      "distance": "{{km}} km away",
      "source_official": "Official",
      "source_advisory": "Advisory",
      "source_report": "Community report",
      "viewAll": "View all alerts"
    },
    "counts": {
      "riskAreas": "{{count}} risk area",
      "riskAreas_plural": "{{count}} risk areas",
      "activeAlerts": "{{count}} active alert",
      "activeAlerts_plural": "{{count}} active alerts",
      "approvedReports": "{{count}} report",
      "approvedReports_plural": "{{count}} reports"
    }
  },
  "home": {
    "testAlertTitle": "Test your alerts",
    "testAlertHint": "Sends a TEST-labelled SMS to your verified phone. Max 3 per day. Excluded from analytics.",
    "testAlertCta": "Send me a test alert",
    "testAlertSending": "Sending…",
    "testAlertQueued": "Test alert sent. Check your phone for a TEST message.",
    "testAlertError": "Could not send test alert",
    "greeting_morning": "Good morning, {{name}}",
    "greeting_afternoon": "Good afternoon, {{name}}",
    "greeting_evening": "Good evening, {{name}}",
    "currentWeather": "Current weather",
    "feelsLike": "Feels like {{temp}}°C",
    "humidity": "{{pct}}% humidity",
    "wind": "{{speed}} km/h wind",
    "rainChance": "{{pct}}% rain",
    "updatedAt": "Updated {{time}}",
    "riskCard": "Risk for {{place}}",
    "noRisk": "No significant flood risk",
    "next24h": "Next 24 hours",
    "forecast3day": "3-day outlook",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "dayAfter": "Day after",
    "thresholdExplain": "WATCH triggered: {{reason}}",
    "activeAlerts": "{{count}} active alert",
    "activeAlerts_plural": "{{count}} active alerts",
    "viewAlerts": "Tap to view",
    "quickActions": "Quick actions",
    "reportHazard": "Report hazard",
    "planRoute": "Plan route",
    "shareLocation": "Share location",
    "emergency": "Emergency numbers",
    "countyEmergency": "{{county}} County Emergency",
    "offline": "Offline — showing data last updated at {{time}}",
    "lastRefreshed": "Data last refreshed: {{time}}",
    "refresh": "Refresh"
  }
}
